import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  marginBottom: 4,
  '&:last-child': {
    marginBottom: 0,
  },
};

const input: SxProps<Theme> = {
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
};

const inputRadio: SxProps<Theme> = {
  flexDirection: 'row',
  justifyContent: 'space-around',
};

const inputRadioOption: SxProps<Theme> = {
  border: '2px solid #ccc',
  width: { xs: '50px', sm: '80px' },
  height: { xs: '50px', sm: '80px' },
  display: 'flex',
  cursor: 'pointer',
  fontSize: {
    xs: 14,
    sm: 20,
  },
  alignItems: 'center',
  borderRadius: '50%',
  justifyContent: 'center',
  '&:hover': {
    border: '2px solid',
    borderColor: 'primary.main',
  },
  input: {
    display: 'none',
  },
};

const squareInputRadioOption = {
  borderRadius: '0',
  borderRight: '0',
  height: {
    xs: '50px',
    sm: '80px',
  },
  fontSize: {
    xs: 14,
    sm: 20,
  },
  ':first-of-type': {
    borderRadius: `4px 0 0 4px`,
  },
  ':last-child': {
    borderRadius: '0 4px 4px 0',
    borderRight: '2px solid #ccc',
    '&:hover': {
      border: '2px solid',
      borderColor: 'primary.main',
    },
  },
};

const questionBox: SxProps<Theme> = {
  padding: 3,
  marginY: 3,
};

const inputRadioOptionChecked = {
  borderColor: 'primary.main',
  bgcolor: 'primary.main',
  color: '#fff',
  border: '2px solid',
};

const answersGroup = {
  width: '100%',
  marginBottom: 30,
  display: 'flex',
};

const numberInputContainer = {
  width: '100%',
};

const styles = {
  container,
  answersGroup,
  questionBox,
  inputRadio,
  input,
  inputRadioOption,
  squareInputRadioOption,
  inputRadioOptionChecked,
  numberInputContainer,
};

export default styles;
